export const CFDI_THREE_VERSION = '3.3';
export const CFDI_FOUR_VERSION = '4.0';



// WEBPACK FOOTER //
// ./src/constants/cfdi.js